'use client';

import { useState, useEffect, useTransition, FC } from 'react';
import { useRouter } from 'next/navigation';
import SiteFooter from '@/hotdesk-ui/components/shared/SiteFooter';
import { Languages } from '../../constants/langulage.constant';
import { getDisplayLanguageCode } from '@/hotdesk-ui/lib/language.service';
import { fetchRemoteConfig, firebaseAnalytics } from '@/hotdesk-ui/common-classes/firebase.service';
import { RemoteConfigKeys } from '@/hotdesk-ui/enum/remote-keys';
interface FooterClientWrapperProps {
  languageCode: string;
}
const FooterClientWrapper: FC<FooterClientWrapperProps> = ({
  languageCode
}) => {
  const router = useRouter();
  const [language, setLanguage] = useState(`language.${languageCode}`);
  const [termLink, setTermLink] = useState('');
  const [helpLink, setHelpLink] = useState('');
  const [blogUrl, setBlogUrl] = useState('/blog');
  const [privacyPolicyLink, setprivacyPolicy] = useState('');
  const availableLanguages = Languages;
  const hostUrl = 'https://host.hotdesk.com/';
  const oneURL = 'https://one.hotdesk.com';
  useEffect(() => {
    startTransition(async () => {
      setLanguage(await getDisplayLanguageCode());
    });
  }, []);
  useEffect(() => {
    getRemoteConfig();
  }, [languageCode]);
  const getRemoteConfig = async () => {
    try {
      let termLinkText = await fetchRemoteConfig(RemoteConfigKeys.TERMS_AND_CONDITIONS_KEY, 'object');
      setTermLink((termLinkText as Record<string, string>)[languageCode]);
      let privacyPolicyLink = await fetchRemoteConfig(RemoteConfigKeys.PRIVACY_KEY, 'object');
      setprivacyPolicy((privacyPolicyLink as Record<string, string>)[languageCode]);
      let helpLink = await fetchRemoteConfig(RemoteConfigKeys.HELPCENTER, 'object');
      setHelpLink((helpLink as Record<string, string>)[languageCode]);
      const blogRouter = (await fetchRemoteConfig(RemoteConfigKeys.WEB_BLOG_ROUTE, 'object')) as string;
      setBlogUrl(blogRouter);
    } catch (error) {
      console.error(error);
    }
  };
  const moveToRoute = (eventName?: string, target?: string) => {
    if (eventName) {
      firebaseAnalytics(eventName, {
        source: 'footer'
      });
    }
  };
  const [isPending, startTransition] = useTransition();
  function osClick() {
    firebaseAnalytics('for_workspaces_clicked', {
      source: 'footer'
    });
  }
  function oneClick() {
    firebaseAnalytics('one_clicked', {
      source: 'footer'
    });
  }
  function appQRCode() {
    firebaseAnalytics('download_app_footer', {
      source: 'footer'
    });
  }
  return <SiteFooter osClick={osClick} oneClick={oneClick} hostUrl={hostUrl} oneURL={oneURL} moveToRoute={moveToRoute} termLink={termLink} privacyPolicyLink={privacyPolicyLink} helpLink={helpLink} appQRCode={appQRCode} blogUrl={blogUrl} data-sentry-element="SiteFooter" data-sentry-component="FooterClientWrapper" data-sentry-source-file="FooterClientWrapper.tsx" />;
};
export default FooterClientWrapper;